import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-oneplus',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>OnePlus icon</title><path d="M0 3.74V24h20.26V12.428h-2.256v9.317H2.254V5.995h9.318V3.742zM18.004 0v3.74h-3.758v2.256h3.758v3.758h2.255V5.996H24V3.74h-3.758V0zm-6.45 18.756V8.862H9.562c0 .682-.228 1.189-.577 1.504-.367.297-.91.437-1.556.437h-.245v1.625h2.133v6.31h2.237z"/></svg>`,
    styles: []
})
export class SimpleIconsOneplusComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#F5010C';
    @Input() className: string = 'simple-icons-oneplus'
    constructor() {}
    ngOnInit(): void {}
}
